import React from "react";

export default () => <svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="4" y="0.416626" width="2" height="2.16667" fill="white"/>
  <rect x="8" y="0.416626" width="2" height="2.16667" fill="white"/>
  <rect y="0.416626" width="2" height="2.16667" fill="white"/>
</svg>
